/**
 * Created by katarinababic on 23.5.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { EventEntry, getEventStartDateTime } from '../Model/Coach/Schedule/EventEntry';
import { useTrans } from '../Store/System/LocalizationStore';
import styled from '@emotion/styled';
import { Theme } from '../Theme/Theme';

function createPlannedText(event?: EventEntry): string | undefined {
  if (event) {
    const startDt = getEventStartDateTime(event);
    const time = startDt.format('LT');
    return event.recurringPattern?.asText(time) ?? startDt.format('LLLL');
  }

  return undefined;
}

const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: white;
  border: 1px solid ${Theme.Colors.lighterGrey};
  border-radius: 12px;
  padding: 14px 16px;
  cursor: pointer;
  margin-bottom: 16px;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${Theme.Colors.primary}30;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
`;

const TextWrapper = styled.div`
  flex: 1;
  text-align: center;
  margin: 0 8px;
  display: flex;
  flex-direction: column;
`;

const PrimaryText = styled.div`
  font-weight: 600;
  color: ${Theme.Colors.black};
`;

const SecondaryText = styled.div`
  font-size: 0.85em;
  color: ${Theme.Colors.lightGrey};
  margin-top: 2px;
`;

const Icon = styled.i`
  color: ${Theme.Colors.lightGrey};
  font-size: 1.2em;
`;

export type ScheduleButtonProps = {
  event?: EventEntry;
  buttonText?: string;
  onClick?: () => void;
};

export const ScheduleButton: React.FC<ScheduleButtonProps> = observer(({ event, buttonText, onClick }) => {
  const { t } = useTrans();

  const isPlanned = !!event;
  const textButton = isPlanned
    ? t('scheduling.changeSchedule', { defaultValue: 'Change schedule' })
    : t('scheduling.notPlanned', { defaultValue: 'Schedule this activity' });
  const scheduledText = React.useMemo(() => createPlannedText(event), [event]);

  return (
    <React.Fragment>
      <Container onClick={onClick}>
        <Icon className="bi bi-calendar" />
        <TextWrapper>
          <PrimaryText>{buttonText ?? textButton}</PrimaryText>
          {scheduledText && <SecondaryText>{scheduledText}</SecondaryText>}
        </TextWrapper>
        <Icon className="bi bi-chevron-right" />
      </Container>
    </React.Fragment>
  );
});
